import {
  INew_TableAction,
  ITimePeriodRequest,
  ITimePeriodWithLocationIds
} from '@lla-platform/core/core-data-access'
import { ObjectiveCategory } from '../../enums/objective-category.enum'
import { IArMovingAverageRequest } from '../../interfaces/ar-moving-average.interface'
import { EmployeeEfficiencyType } from '../../enums/employee-efficiency-type.enum'
import { IUpsellRequest } from '../../interfaces/upsell.interface'
import { IDailyAverageRequest } from '../../interfaces/daily-average.interface'
import { ICompareReportRequest } from '../../interfaces/compare-report.interface'
import { IAdjustedGPRequest } from '../../interfaces/adjusted-gross-profit.interface'

export class GetCallsReport {
  static readonly type = '[reports] Get Calls Report'
  constructor(public payload: ITimePeriodRequest) {}
}

export class GetSalesReport {
  static readonly type = '[reports] Get Sales Report'
  constructor(public payload: ITimePeriodWithLocationIds) {}
}

export class GetTiresReport {
  static readonly type = '[reports] Get Tires Report'
  constructor(public payload: ITimePeriodWithLocationIds) {}
}

export class GetCompareReport {
  static readonly type = '[reports] Get Compare Report'
  constructor(public payload: ICompareReportRequest) {}
}

export class GetWeeklyObjectivesRankingReport {
  static readonly type = '[reports] Get Weekly Objectives Ranking Report'
  constructor(public objectiveCategory: ObjectiveCategory) {}
}

export class GetMonthlyObjectivesRankingReport {
  static readonly type = '[reports] Get Monthly Objectives Ranking Report'
  constructor(public objectiveCategory: ObjectiveCategory) {}
}

export class GetWeeklyArMovingAverageReport {
  static readonly type = '[reports] Get Weekly Ar Moving Average Report'
  constructor(public payload: IArMovingAverageRequest) {}
}

export class GetMonthlyArMovingAverageReport {
  static readonly type = '[reports] Get Monthly Ar Moving Average Report'
  constructor(public payload: IArMovingAverageRequest) {}
}

export class GetWeeklyCategoryMovingAverageReport {
  static readonly type = '[reports] Get Weekly Category Moving Average Report'
  constructor(public serviceCategoryId: string) {}
}

export class GetMonthlyCategoryMovingAverageReport {
  static readonly type = '[reports] Get Monthly Category Moving Average Report'
  constructor(public serviceCategoryId: string) {}
}

export class GetWeeklyEmployeeEfficiencyRankingReport {
  static readonly type = '[reports] Get Weekly Employee Efficiency Ranking Report'
  constructor(public employeeEfficiencyType: EmployeeEfficiencyType) {}
}

export class GetMonthlyEmployeeEfficiencyRankingReport {
  static readonly type = '[reports] Get Monthly Employee Efficiency Ranking Report'
  constructor(public employeeEfficiencyType: EmployeeEfficiencyType) {}
}

export class GetUpsellReport {
  static readonly type = '[reports] Get Upsell Report'
  constructor(public payload: IUpsellRequest) {}
}

export class GetUpsellList {
  static readonly type = '[reports] Get Upsell List'
  constructor(public info: INew_TableAction) {}
}

export class GetDailyAverageReport {
  static readonly type = '[reports] Get Daily Average Report'
  constructor(public payload: IDailyAverageRequest) {}
}

export class GetCompareObjectivesByGroup {
  static readonly type = '[reports] Get Compare Objectives By Group'
  constructor(
    public numberOfMonths: number,
    public locationIds: string[] = []
  ) {}
}

export class GetCompareObjectivesByRegional {
  static readonly type = '[reports] Get Compare Objectives By Regional'
  constructor(
    public numberOfMonths: number,
    public locationIds: string[] = []
  ) {}
}

export class GetAdjustedGP {
  static readonly type = '[reports] Get Adjusted GP'
  constructor(public payload: IAdjustedGPRequest) {}
}

export class ClearAdjustedGP {
  static readonly type = '[reports] Clear Adjusted GP'
}
